var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.33334V8.00001C10 8.73334 9.40004 9.33334 8.66671 9.33334H1.33337V4.00001C1.33337 2.52668 2.52671 1.33334 4.00004 1.33334H10Z",
    stroke: "#666D80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 9.33334V11.3333C14.6667 12.44 13.7734 13.3333 12.6667 13.3333H12C12 12.6 11.4 12 10.6667 12C9.93337 12 9.33337 12.6 9.33337 13.3333H6.66671C6.66671 12.6 6.06671 12 5.33337 12C4.60004 12 4.00004 12.6 4.00004 13.3333H3.33337C2.22671 13.3333 1.33337 12.44 1.33337 11.3333V9.33334H8.66671C9.40004 9.33334 10 8.73334 10 8.00001V3.33334H11.2267C11.7067 3.33334 12.1467 3.59335 12.3867 4.00668L13.5267 6.00001H12.6667C12.3 6.00001 12 6.30001 12 6.66668V8.66668C12 9.03334 12.3 9.33334 12.6667 9.33334H14.6667Z",
    stroke: "#666D80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 14.6667C6.06971 14.6667 6.66667 14.0697 6.66667 13.3333C6.66667 12.597 6.06971 12 5.33333 12C4.59695 12 4 12.597 4 13.3333C4 14.0697 4.59695 14.6667 5.33333 14.6667Z",
    stroke: "#666D80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 14.6667C11.4031 14.6667 12 14.0697 12 13.3333C12 12.597 11.4031 12 10.6667 12C9.93033 12 9.33337 12.597 9.33337 13.3333C9.33337 14.0697 9.93033 14.6667 10.6667 14.6667Z",
    stroke: "#666D80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 8V9.33333H12.6667C12.3 9.33333 12 9.03333 12 8.66667V6.66667C12 6.3 12.3 6 12.6667 6H13.5267L14.6667 8Z",
    stroke: "#666D80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.f5606f70e050d31f6de6ff025dd14b41.svg";
export { ForwardRef as ReactComponent };